var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 447 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 210.01,
    cy: 210.01,
    r: 199.241
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5876865,0 L104.941665,12.287234 L104.941665,36.8617021 L83.5876865,49.1489362 L62.2325338,36.8617021 L62.2325338,12.287234 L83.5876865,0 Z M144.646022,0 L166,12.287234 L166,36.8617021 L144.646022,49.1489362 L123.290869,36.8617021 L123.290869,12.287234 L144.646022,0 Z M21.3551527,57.3404255 L42.7091312,69.6276596 L42.7091312,94.2021277 L21.3551527,106.489362 L0,94.2021277 L0,69.6276596 L21.3551527,57.3404255 Z M83.5876865,57.3404255 L104.941665,69.6276596 L104.941665,94.2021277 L83.5876865,106.489362 L62.2325338,94.2021277 L62.2325338,69.6276596 L83.5876865,57.3404255 Z M144.646022,57.3404255 L166,69.6276596 L166,94.2021277 L144.646022,106.489362 L123.290869,94.2021277 L123.290869,69.6276596 L144.646022,57.3404255 Z M21.3551527,115.851064 L42.7091312,128.138298 L42.7091312,152.712766 L21.3551527,165 L0,152.712766 L0,128.138298 L21.3551527,115.851064 Z M83.5876865,115.851064 L104.941665,128.138298 L104.941665,152.712766 L83.5876865,165 L62.2325338,152.712766 L62.2325338,128.138298 L83.5876865,115.851064 Z M144.646022,115.851064 L166,128.138298 L166,152.712766 L144.646022,165 L123.290869,152.712766 L123.290869,128.138298 L144.646022,115.851064 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "21.0005774 0 42 12.5 42 37.5 21.0005774 50 0 37.5 0 12.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.0329544653 0.598210393 33.9651777 0.598210393 33.9651777 22.6930752 0.0329544653 22.6930752"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 0.414944234 246.123936 0.414944234 246.123936 222.55713 0 222.55713"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0.0191404471 0.347449558 19.727484 0.347449558 19.727484 13.180478 0.0191404471 13.180478"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0 0.241005827 142.952469 0.241005827 142.952469 129.264515 0 129.264515"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "0.0125980618 0.228688023 12.984444 0.228688023 12.984444 8.67526639 0.0125980618 8.67526639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0 0.158627763 94.0899675 0.158627763 94.0899675 85.0806853 0 85.0806853"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes maskMove{0%,30%,40%,75%,80%{y:447px}15%,20%,50%,55%,95%,to{y:-447px}}@keyframes wrenchFrontWalk{0%{transform:translateX(-125px) translateY(75px)}3.33%{transform:translateX(-65px) translateY(25px)}6.66%{transform:translateX(-5px) translateY(75px)}10%{transform:translateX(55px) translateY(25px)}13.33%{transform:translateX(115px) translateY(75px)}16.66%{transform:translateX(175px) translateY(25px)}20%{transform:translateX(235px) translateY(75px)}23.33%{transform:translateX(295px) translateY(25px)}26.66%{transform:translateX(355px) translateY(75px)}30%{transform:translateX(415px) translateY(25px)}33.33%,to{transform:translateX(475px) translateY(75px)}}@keyframes wrenchMiddleLook{0%,33.33%,63.33%,to{transform:translateX(-100px) translateY(100px)}43.33%,60%{transform:translateX(0) translateY(0)}46.66%{transform:translateX(-5px) translateY(-5px)}50%{transform:translateX(-3px) translateY(30px)}53.33%,56.66%{transform:translateX(0) translateY(32px) rotate(5deg)}}@keyframes wrenchBackLook{0%,63.33%{transform:translateX(-80px) translateY(80px)}73.33%,76.66%,93.33%,96.66%{transform:translateX(0) translateY(0)}80%{transform:translateX(-5px) translateY(-5px)}83.33%{transform:translateX(-3px) translateY(30px)}86.66%,90%{transform:translateX(0) translateY(32px) rotate(5deg)}to{transform:translateX(-100px) translateY(100px)}}#bolts-color{animation:maskMove ease-in-out 10s infinite alternate}#wrench-front-right-animation-group{animation:wrenchFrontWalk ease 10s infinite normal running}#wrench-middle-left-animation-group{animation:wrenchMiddleLook ease 10s infinite normal running}#wrench-back-top-animation-group{animation:wrenchBackLook ease 10s infinite normal running}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "border",
    stroke: "#A6ACBA",
    strokeWidth: 2,
    fillRule: "nonzero",
    cx: 210.5,
    cy: 210.5,
    r: 210.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bolts-and-color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132 132)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "most-bolts",
    stroke: "none",
    fill: "#D7DBE3",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bolts-color",
    stroke: "none",
    fill: "#D0011B",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: -141,
    y: 0,
    width: 447,
    height: 447
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "top-left-bolt",
    stroke: "none",
    fill: "#D0011B",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wrench-front-right",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-4 3182.696 7574.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wrench-front-right-animation-group",
    transform: "translate(-125 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "rotate(2 -18.134 238.47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(244.48 67.75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0329544653,13.4056787 L3.88168157,22.6930752 C3.88168157,22.6930752 25.6089713,12.6618797 33.9651777,0.598210393 L0.0329544653,13.4071201 L0.0329544653,13.4056787 Z",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(8.311 1.649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.113493,25.2111254 L244.532552,10.7560559 C244.532552,10.7560559 226.619394,-4.72534073 191.128941,4.22042721 C191.128941,4.22042721 167.700716,62.0291732 149.097093,78.5469874 L9.55983452,185.906293 C9.55983452,185.906293 3.35430261,194.854944 4.39072013,201.737967 C5.42281325,208.616666 14.380113,218.941921 24.0293187,218.25434 C33.6756414,217.565317 36.7762452,211.714387 40.5673134,208.962619 C44.3583817,206.20941 173.903365,98.8486625 173.903365,98.8486625 C179.331697,96.6040418 184.934043,94.8058532 190.654697,93.4719763 C204.53462,90.2430817 216.753968,90.3151552 225.760278,91.1713889 C227.005709,91.2059842 228.597092,91.1180545 230.390282,90.697145 C232.669487,90.1605213 234.825494,89.1943054 236.742844,87.8502401 L211.113493,25.2111254",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-10)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "wrench-middle-left",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4 2746.702 698.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wrench-middle-left-animation-group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "rotate(2 -10.532 138.507)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(141.997 39.35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0191404471,7.78621901 L2.25453881,13.180478 C2.25453881,13.180478 14.8740742,7.35420944 19.727484,0.347449558 L0.0191404471,7.78705623 L0.0191404471,7.78621901 Z",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.827 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.617879,14.6429993 L142.02817,6.24727842 C142.02817,6.24727842 131.623939,-2.74454869 111.010552,2.45128735 C111.010552,2.45128735 97.4030881,36.0274731 86.5978255,45.621267 L5.5524951,107.97716 C5.5524951,107.97716 1.94822921,113.174671 2.55019603,117.172434 C3.14965117,121.167685 8.35218503,127.164748 13.9565883,126.76539 C19.559317,126.365195 21.3601941,122.966887 23.5621034,121.36862 C25.7640126,119.769514 101.00568,57.412784 101.00568,57.412784 C104.158536,56.1090747 107.412463,55.0646598 110.735104,54.2899242 C118.796771,52.4145338 125.893952,52.4563952 131.124951,52.9537085 C131.848316,52.973802 132.772616,52.9227311 133.814127,52.6782605 C135.137924,52.3665814 136.390165,51.8053888 137.50379,51.0247355 L122.617879,14.6429993",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-14)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "wrench-back-top-right",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(74 -161.512 -189.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wrench-back-top-animation-group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(93.461 25.9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0125980618,5.12481594 L1.48391619,8.67526639 C1.48391619,8.67526639 9.7899754,4.84047132 12.984444,0.228688023 L0.0125980618,5.125367 L0.0125980618,5.12481594 Z",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.177 .63)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7059321,9.63788409 L93.4816023,4.11189976 C93.4816023,4.11189976 86.6336359,-1.80643607 73.066099,1.61341422 C73.066099,1.61341422 64.1097943,23.7129431 56.9978723,30.0274878 L3.65459993,71.0695487 C3.65459993,71.0695487 1.2823061,74.4905012 1.67851499,77.1217911 C2.07307071,79.7514278 5.49732945,83.6986382 9.18609481,83.4357847 C12.8737581,83.1723802 14.0590784,80.935646 15.5083543,79.8836811 C16.9576302,78.8311651 66.480986,37.7885532 66.480986,37.7885532 C68.5561666,36.930464 70.6978702,36.24304 72.8848017,35.7331162 C78.1909149,34.498752 82.8622122,34.5263047 86.3052068,34.8536317 C86.7813187,34.866857 87.389684,34.8332426 88.075197,34.6723344 C88.9465074,34.4671902 89.7707207,34.0978185 90.5036985,33.5839999 L80.7059321,9.63788409",
    id: "Shape",
    fill: "#A6ACBA",
    fillRule: "nonzero",
    mask: "url(#mask-18)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ad5671c206ee3dd772e740a3d01286a7.svg";
export { ForwardRef as ReactComponent };